// import React, {useEffect, useState} from 'react';
// import {addDays, formatDate} from "../../Utis/GlobalFunctions";
// import axios from "axios";
// import Swal from "sweetalert2";
//
// const DonationForm = () => {
//     const [loading,setLoading] = useState(false)
//     const [currentDate] = useState(new Date())
//     const newDate = addDays(currentDate, 3);
//     const [step, setStep] = useState(1);
//     const [donationType, setDonationType] = useState('once');
//     const [currency, setCurrency] = useState('PKR');
//     const [donationAmount, setDonationAmount] = useState('');
//     const [donationPurpose, setDonationPurpose] = useState('general');
//     const [showCustomAmount, setShowCustomAmount] = useState(false);
//     const [credentials,setCredentails] = useState({
//         username: "",
//         password: "",
//         clientId: "",
//         clientSecret: ""
//     });
//     const [userInfo, setUserInfo] = useState({
//         firstName: '',
//         lastName: '',
//         email: '',
//         contactNumber: '',
//         address: '',
//         country: 'Pakistan',
//         province: '',
//         zipCode: '',
//         city: '',
//         amount:'',
//         currency:"PKR",
//         donationPurpose:""
//     });
//
//     const nextStep = () => setStep(step + 1);
//     const prevStep = () => setStep(step - 1);
//
//     const handleSubmit = (e) => {
//         e.preventDefault();
//         // Handle form submission
//         console.log({ donationType, currency, donationAmount, donationPurpose, userInfo });
//     };
//
//     const handleUserInfoChange = (e) => {
//         const { name, value } = e.target;
//         setUserInfo({ ...userInfo, [name]: value });
//     };
//
//     let payload
//     if(userInfo.currency === "PKR") {
//         payload = [
//             {
//                 MerchantId: credentials?.username
//             },
//             {
//                 OrderNumber: `${+currentDate}`,
//                 OrderAmount: userInfo?.amount,
//                 OrderDueDate: formatDate(newDate),
//                 OrderType: "Service",
//                 IssueDate: formatDate(currentDate),
//                 OrderExpireAfterSeconds: "0",
//                 CustomerName: userInfo?.firstName +" "+ userInfo?.lastName,
//                 CustomerMobile: userInfo?.contactNumber??"",
//                 CustomerEmail: userInfo?.email,
//                 CustomerAddress: userInfo?.address,
//                 BillDetail01: [
//                     {
//                         internationalNumber: userInfo?.currency === "USD" || userInfo?.currency === "AED"   ? userInfo?.contactNumber : "",
//                         purposeOfDonation:userInfo?.donationPurpose,
//                         zipCode:userInfo.zipCode
//                     }
//                 ]
//             }
//         ];
//     }else {
//         payload = [
//             {
//                 MerchantId: credentials?.username
//             },
//             {
//                 OrderNumber: `${+currentDate}`,
//                 CurrencyAmount: userInfo?.amount,
//                 OrderDueDate: formatDate(newDate),
//                 OrderType: "Service",
//                 IssueDate: formatDate(currentDate),
//                 OrderExpireAfterSeconds: "0",
//                 CustomerName: userInfo?.firstName +" "+ userInfo?.lastName,
//                 CustomerMobile: userInfo?.currency === "PKR" ? userInfo?.phoneNumber : "",
//                 CustomerEmail: userInfo?.email,
//                 CustomerAddress: userInfo?.address,
//                 Currency: userInfo?.currency,
//                 IsConverted  : "true",
//                 BillDetail01: [
//                     {
//                         internationalNumber: userInfo?.currency === "USD" || userInfo?.currency === "AED"  ? userInfo?.phoneNumber : "",
//                         purposeOfDonation:userInfo?.donationPurpose,
//                         zipCode:userInfo.zipCode
//
//                     }
//                 ]
//             }
//         ];
//     }
//
//     const getAuthToken = async (clientId, clientSecret) => {
//         const tokenResponse = await axios.post(`${process.env.REACT_APP_PAYPRO_LIVEAPI}/auth`, {
//             clientid: clientId,
//             clientsecret: clientSecret,
//         });
//         return tokenResponse.data.token;
//     };
//
//     const payproCreateOrder = async (e) => {
//         e.preventDefault();
//
//
//
//         // Validate the form before submission
//         // const isValid = validateForm();
//         // if (!isValid) {
//         //     // If the form has errors, prevent submission
//         //     return;
//         // }
//
//         try {
//             setLoading(true);
//             const token = await getAuthToken(credentials.clientId, credentials.clientSecret);
//             const headers = { 'token': token, 'Content-Type': 'application/json' };
//             const url = `${process.env.REACT_APP_PAYPRO_LIVEAPI}/create-order`;
//             const response = await axios.post(url, payload, { headers });
//
//             if(response.data?.data[0].Status === "03") {
//                 console.log(response.data.data[1].Description)
//                 await Swal.fire({
//                     icon: "error",
//                     title: response?.data?.data[1]?.Description,
//                     showConfirmButton: false,
//                     timer: 1500
//                 });
//                 setLoading(false)
//             }else {
//                 const marketplaceUrl = response.data?.data[1]?.Click2Pay
//                 await Swal.fire({
//                     icon: "success",
//                     title: "Redirecting to Marketplace",
//                     showConfirmButton: false,
//                     timer: 1500
//                 });
//                 setLoading(false)
//                 // window.top.location.href = marketplaceUrl+"&callback_url=https://fixit.org.pk/thankyou-for-your-contribution";
//                 window.top.location.href = marketplaceUrl;
//             }
//
//             // return response.data;
//
//
//         } catch (error) {
//             console.error('Error creating order:', error);
//             setLoading(false)
//         }
//
//     }
//
//     useEffect(() => {
//         console.log(userInfo,"userInfo")
//     }, [userInfo]);
//
//
//     useEffect(() => {
//         setCredentails(prev => ({
//             ...prev, // Keep other values if needed
//             username: userInfo.donationPurpose === "Zakat" ? "AkbarKare_Zakat" : "AkbarKare_Donat",
//             password: userInfo.donationPurpose === "Zakat" ? "Live@az25" : "Live@ad25",
//             clientId: userInfo.donationPurpose === "Zakat" ? "sDxGjWf1yDiwS2D" : "fT0jCiuTEF6UIkL",
//             clientSecret: userInfo.donationPurpose === "Zakat" ? "1WNcjOvBwxlOqXe" : "nxQKvxdNFjZy3Bz"
//         }));
//     }, [userInfo.donationType]);
//
//     return (
//         <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-md">
//             <h2 className="text-xl font-semibold mb-4">Donation Form</h2>
//             <form onSubmit={payproCreateOrder}>
//                 {step === 1 && (
//
//                     <div>
//                         <div className="mb-4">
//                             <select className="block w-full px-4 py-2 rounded border text-center border-gray-300">
//                                 <option  value="education1">General Education</option>
//                                 {/*<option value="education1">Educate a Child</option>*/}
//                                 {/*<option value="education1">Support a Classroom</option>*/}
//                                 {/*<option value="education1">Support a Child: KG to Matric</option>*/}
//                             </select>
//                         </div>
//
//                         <label className="block text-gray-700 text-sm font-bold mb-2">Donation Type</label>
//                         <div className="flex space-x-4 mb-4">
//                             <button
//                                 type="button"
//                                 onClick={() => {
//                                     setDonationType('once')
//                                 }
//
//                             }
//                                 className={`px-4 py-2 rounded ${donationType === 'once' ? 'bg-red-500 text-white' : 'bg-gray-200 text-gray-700'}`}
//                             >
//                                 Give Once
//                             </button>
//
//                         </div>
//                         <div>
//                             <label className="block text-gray-700 text-sm font-bold mb-2">Currency</label>
//                             <div className="flex space-x-4 mb-4">
//                                 {['PKR',"USD", 'AED'].map((curr) => (
//                                     <button
//                                         key={curr}
//                                         type="button"
//                                         onClick={() => {
//                                             setCurrency(curr);
//                                             setUserInfo(prev => ({ ...prev, currency: curr })); // Set currency in userInfo
//                                         }}
//                                         className={`px-4 py-2 rounded ${
//                                             currency === curr ? 'bg-red-500 text-white' : 'bg-gray-200 text-gray-700'
//                                         }`}
//                                     >
//                                         {curr}
//                                     </button>
//                                 ))}
//                             </div>
//
//                             <div>
//                                 <label className="block text-gray-700 text-sm font-bold mb-2">Amount</label>
//                                 <div className="grid grid-cols-3 gap-2 mb-4">
//                                     {["100", "1000", "2000"].map((amount) => (
//                                         <button
//                                             key={amount}
//                                             type="button"
//                                             onClick={() => {
//                                                 setDonationAmount(amount);
//                                                 setShowCustomAmount(false);
//                                                 setUserInfo(prev => ({ ...prev, amount: amount }));
//                                             }}
//                                             className={`px-4 py-2 rounded ${donationAmount === amount && !showCustomAmount ? 'bg-red-500 text-white' : 'bg-gray-200 text-gray-700'}`}
//                                         >
//                                             {currency} {amount}
//                                         </button>
//                                     ))}
//                                     <button
//                                         type="button"
//                                         onClick={() => {
//                                             setShowCustomAmount(!showCustomAmount);
//                                             setDonationAmount('');
//                                         }}
//                                         className={`px-4 py-2 rounded ${showCustomAmount ? 'bg-red-500 text-white' : 'bg-gray-200 text-gray-700'}`}
//                                     >
//                                         Other
//                                     </button>
//                                 </div>
//                                 {showCustomAmount && (
//                                     <input
//                                         type="number"
//                                         placeholder="Enter custom amount"
//                                         value={userInfo.amount || ''}
//                                         onChange={(e) => {
//                                             // setDonationAmount(e.target.value)
//                                             setUserInfo(prev => ({ ...prev, amount: e.target.value }));
//
//                                         }}
//                                         className="mb-4 px-4 py-2 rounded border border-gray-300 w-full"
//                                     />
//                                 )}
//
//                                 <label className="block text-gray-700 text-sm font-bold mb-2">Donation Purpose</label>
//
//
//                                 <div className="flex space-x-4 mb-4">
//                                     {['General', 'Zakat', 'Sadqah'].map((curr) => (
//                                         <button
//                                             key={curr}
//                                             type="button"
//                                             onClick={() => {
//                                                 setDonationPurpose(curr)
//                                                 setUserInfo(prev => ({ ...prev, donationPurpose: curr }));
//                                             }}
//                                             className={`px-4 py-2 rounded ${donationPurpose === curr ? 'bg-red-500 text-white' : 'bg-gray-200 text-gray-700'}`}
//                                         >
//                                             {curr}
//                                         </button>
//                                     ))}
//                                 </div>
//
//
//                             </div>
//                         </div>
//                         <button
//                             type="button"
//                             onClick={nextStep}
//                             className="w-full bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
//                         >
//                             Next
//                         </button>
//                     </div>
//                 )}
//
//                 {step === 2 && (
//                     <div>
//                         <h3 className="text-lg font-semibold mb-4">Enter Your Information</h3>
//                         <div className="space-y-4">
//                             <div className="grid grid-cols-2 gap-4">
//                                 <input
//                                     type="text"
//                                     name="firstName"
//                                     placeholder="First Name"
//                                     value={userInfo.firstName}
//                                     onChange={handleUserInfoChange}
//                                     className="px-4 py-2 rounded border border-gray-300"
//                                 />
//                                 <input
//                                     type="text"
//                                     name="lastName"
//                                     placeholder="Last Name"
//                                     value={userInfo.lastName}
//                                     onChange={handleUserInfoChange}
//                                     className="px-4 py-2 rounded border border-gray-300"
//                                 />
//                             </div>
//                             <input
//                                 type="email"
//                                 name="email"
//                                 placeholder="Email"
//                                 value={userInfo.email}
//                                 onChange={handleUserInfoChange}
//                                 className="w-full px-4 py-2 rounded border border-gray-300"
//                             />
//                             <input
//                                 type="text"
//                                 name="contactNumber"
//                                 placeholder="Contact Number"
//                                 value={userInfo.contactNumber}
//                                 onChange={handleUserInfoChange}
//                                 className="w-full px-4 py-2 rounded border border-gray-300"
//                             />
//                             <input
//                                 type="text"
//                                 name="address"
//                                 placeholder="Address"
//                                 value={userInfo.address}
//                                 onChange={handleUserInfoChange}
//                                 className="w-full px-4 py-2 rounded border border-gray-300"
//                             />
//                             <div className="grid grid-cols-2 gap-4">
//                                 <select
//                                     name="country"
//                                     value={userInfo.country}
//                                     onChange={handleUserInfoChange}
//                                     className="px-4 py-2 rounded border border-gray-300"
//                                 >
//                                     <option value="Pakistan">Pakistan</option>
//                                     {/* Add other countries if needed */}
//                                 </select>
//                                 <select
//                                     name="province"
//                                     value={userInfo.province}
//                                     onChange={handleUserInfoChange}
//                                     className="px-4 py-2 rounded border border-gray-300"
//                                 >
//                                     <option value="">Select Province</option>
//                                     <option value="Sindh">Sindh</option>
//                                     <option value="Punjab">Punjab</option>
//                                     <option value="Balochistan">Balochistan</option>
//                                     <option value="KPK">KPK</option>
//                                 </select>
//                             </div>
//                             <div className="grid grid-cols-2 gap-4">
//                                 <input
//                                     type="text"
//                                     name="zipCode"
//                                     placeholder="Zip/Postal Code"
//                                     value={userInfo.zipCode}
//                                     onChange={handleUserInfoChange}
//                                     className="px-4 py-2 rounded border border-gray-300"
//                                 />
//                                 <input
//                                     type="text"
//                                     name="city"
//                                     placeholder="City"
//                                     value={userInfo.city}
//                                     onChange={handleUserInfoChange}
//                                     className="px-4 py-2 rounded border border-gray-300"
//                                 />
//                             </div>
//                         </div>
//                         <div className="flex justify-between mt-4">
//                             <button
//                                 type="button"
//                                 onClick={prevStep}
//                                 className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
//                             >
//                                 Back
//                             </button>
//                             <button
//                                 type="submit"
//                                 className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
//                             >
//                                 Submit
//                             </button>
//                         </div>
//                     </div>
//                 )}
//
//                 {/*{step === 3 && (*/}
//                 {/*    <div>*/}
//                 {/*        <h3 className="text-lg font-semibold mb-4">Review Your Donation</h3>*/}
//                 {/*        <div className="mb-4">*/}
//                 {/*            <p><strong>Donation Type:</strong> {donationType}</p>*/}
//                 {/*            <p><strong>Currency:</strong> {currency}</p>*/}
//                 {/*            <p><strong>Amount:</strong> {currency} {donationAmount}</p>*/}
//                 {/*            <p><strong>Purpose:</strong> {donationPurpose}</p>*/}
//                 {/*            {donationPurpose === 'general' && <p><strong>General Education:</strong> Selected Option</p>}*/}
//                 {/*            <p><strong>First Name:</strong> {userInfo.firstName}</p>*/}
//                 {/*            <p><strong>Last Name:</strong> {userInfo.lastName}</p>*/}
//                 {/*            <p><strong>Email:</strong> {userInfo.email}</p>*/}
//                 {/*            <p><strong>Contact Number:</strong> {userInfo.contactNumber}</p>*/}
//                 {/*            <p><strong>Address:</strong> {userInfo.address}</p>*/}
//                 {/*            <p><strong>Country:</strong> {userInfo.country}</p>*/}
//                 {/*            <p><strong>Province:</strong> {userInfo.province}</p>*/}
//                 {/*            <p><strong>Zip/Postal Code:</strong> {userInfo.zipCode}</p>*/}
//                 {/*            <p><strong>City:</strong> {userInfo.city}</p>*/}
//                 {/*        </div>*/}
//
//                 {/*    </div>*/}
//                 {/*)}*/}
//             </form>
//         </div>
//     );
// };
//
// export default DonationForm;


import React, { useEffect, useState } from 'react';
import { addDays, formatDate } from "../../Utis/GlobalFunctions";
import axios from "axios";
import Swal from "sweetalert2";

const DonationForm = () => {
    const [loading, setLoading] = useState(false);
    const [currentDate] = useState(new Date());
    const newDate = addDays(currentDate, 3);
    const [step, setStep] = useState(1);
    const [donationType, setDonationType] = useState('once');
    const [currency, setCurrency] = useState('PKR');
    const [donationAmount, setDonationAmount] = useState('');
    const [donationPurpose, setDonationPurpose] = useState('General'); // Default donation purpose
    const [showCustomAmount, setShowCustomAmount] = useState(false);
    const [credentials, setCredentials] = useState({
        username: "",
        password: "",
        clientId: "",
        clientSecret: ""
    });
    const [userInfo, setUserInfo] = useState({
        firstName: '',
        lastName: '',
        email: '',
        contactNumber: '',
        address: '',
        country: 'Pakistan',
        province: '',
        zipCode: '',
        city: '',
        amount: '',
        currency: "PKR",
        donationPurpose: "General" // Default donation purpose in userInfo
    });

    const nextStep = () => {
        if (validateStep1()) {
            setStep(step + 1);
        }
    };

    const prevStep = () => setStep(step - 1);

    const validateStep1 = () => {
        if (!donationAmount) {
            Swal.fire({
                icon: "error",
                title: "Please select or enter a donation amount.",
                showConfirmButton: false,
                timer: 1500
            });
            return false;
        }
        if (!donationPurpose) {
            Swal.fire({
                icon: "error",
                title: "Please select a donation purpose.",
                showConfirmButton: false,
                timer: 1500
            });
            return false;
        }
        return true;
    };

    const validateStep2 = () => {
        const requiredFields = ['firstName', 'lastName', 'email', 'contactNumber', 'address', 'province', 'zipCode', 'city'];
        for (const field of requiredFields) {
            if (!userInfo[field]) {
                Swal.fire({
                    icon: "error",
                    title: `Please fill out the ${field.replace(/([A-Z])/g, ' $1').toLowerCase()} field.`,
                    showConfirmButton: false,
                    timer: 1500
                });
                return false;
            }
        }
        return true;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log({ donationType, currency, donationAmount, donationPurpose, userInfo });
    };

    const handleUserInfoChange = (e) => {
        const { name, value } = e.target;
        setUserInfo({ ...userInfo, [name]: value });
    };

    let payload;
    if (userInfo.currency === "PKR") {
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                OrderAmount: userInfo?.amount,
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: userInfo?.firstName + " " + userInfo?.lastName,
                CustomerMobile: userInfo?.contactNumber ?? "",
                CustomerEmail: userInfo?.email,
                CustomerAddress: userInfo?.address,
                BillDetail01: [
                    {
                        internationalNumber: userInfo?.currency === "USD" || userInfo?.currency === "AED" ? userInfo?.contactNumber : "",
                        purposeOfDonation: userInfo?.donationPurpose,
                        zipCode: userInfo.zipCode
                    }
                ]
            }
        ];
    } else {
        payload = [
            {
                MerchantId: credentials?.username
            },
            {
                OrderNumber: `${+currentDate}`,
                CurrencyAmount: userInfo?.amount,
                OrderDueDate: formatDate(newDate),
                OrderType: "Service",
                IssueDate: formatDate(currentDate),
                OrderExpireAfterSeconds: "0",
                CustomerName: userInfo?.firstName + " " + userInfo?.lastName,
                CustomerMobile: userInfo?.currency === "PKR" ? userInfo?.phoneNumber : "",
                CustomerEmail: userInfo?.email,
                CustomerAddress: userInfo?.address,
                Currency: userInfo?.currency,
                IsConverted: "true",
                BillDetail01: [
                    {
                        internationalNumber: userInfo?.currency === "USD" || userInfo?.currency === "AED" ? userInfo?.phoneNumber : "",
                        purposeOfDonation: userInfo?.donationPurpose,
                        zipCode: userInfo.zipCode

                    }
                ]
            }
        ];
    }

    const getAuthToken = async (clientId, clientSecret) => {
        const tokenResponse = await axios.post(`${process.env.REACT_APP_PAYPRO_LIVEAPI}/auth`, {
            clientid: clientId,
            clientsecret: clientSecret,
        });
        return tokenResponse.data.token;
    };

    const payproCreateOrder = async (e) => {
        e.preventDefault();

        if (!validateStep2()) {
            return;
        }

        try {
            setLoading(true);
            const token = await getAuthToken(credentials.clientId, credentials.clientSecret);
            const headers = { 'token': token, 'Content-Type': 'application/json' };
            const url = `${process.env.REACT_APP_PAYPRO_LIVEAPI}/create-order`;
            const response = await axios.post(url, payload, { headers });

            if (response.data?.data[0].Status === "03") {
                console.log(response.data.data[1].Description)
                await Swal.fire({
                    icon: "error",
                    title: response?.data?.data[1]?.Description,
                    showConfirmButton: false,
                    timer: 1500
                });
                setLoading(false)
            } else {
                const marketplaceUrl = response.data?.data[1]?.Click2Pay
                await Swal.fire({
                    icon: "success",
                    title: "Redirecting to Marketplace",
                    showConfirmButton: false,
                    timer: 1500
                });
                setLoading(false)
                window.top.location.href = marketplaceUrl;
            }

        } catch (error) {
            console.error('Error creating order:', error);
            setLoading(false)
        }

    }

    useEffect(() => {
        console.log(userInfo, "userInfo")
    }, [userInfo]);


    useEffect(() => {
        setCredentials(prev => ({
            ...prev, // Keep other values if needed
            username: userInfo.donationPurpose === "Zakat" ? "AkbarKare_Zakat" : "AkbarKare_Donat",
            password: userInfo.donationPurpose === "Zakat" ? "Live@az25" : "Live@ad25",
            clientId: userInfo.donationPurpose === "Zakat" ? "sDxGjWf1yDiwS2D" : "fT0jCiuTEF6UIkL",
            clientSecret: userInfo.donationPurpose === "Zakat" ? "1WNcjOvBwxlOqXe" : "nxQKvxdNFjZy3Bz"
        }));
    }, [userInfo.donationType]);

    return (
        <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-md">
            <h2 className="text-xl font-semibold mb-4">Donation Form</h2>
            <form onSubmit={payproCreateOrder}>
                {step === 1 && (
                    <div>
                        <div className="mb-4">
                            <select className="block w-full px-4 py-2 rounded border text-center border-gray-300">
                                <option value="education1">Early Intervention</option>
                                {<option value="education1">Physical Therapy</option>}
                                {<option value="education1">Assistive Device</option>}
                                {<option value="education1">Early Education</option>}
                                {<option value="education1">Sponsor a child</option>}
                            </select>
                        </div>

                        <label className="block text-gray-700 text-sm font-bold mb-2">Donation Type</label>
                        <div className="flex space-x-4 mb-4">
                            <button
                                type="button"
                                onClick={() => {
                                    setDonationType('once')
                                }}
                                className={`px-4 py-2 rounded ${donationType === 'once' ? 'bg-blue-800 text-white' : 'bg-gray-200 text-gray-700'}`}
                            >
                                Give Once
                            </button>
                        </div>
                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-2">Currency</label>
                            <div className="flex space-x-4 mb-4">
                                {['PKR', "USD", 'AED'].map((curr) => (
                                    <button
                                        key={curr}
                                        type="button"
                                        onClick={() => {
                                            setCurrency(curr);
                                            setUserInfo(prev => ({ ...prev, currency: curr }));
                                        }}
                                        className={`px-4 py-2 rounded ${currency === curr ? 'bg-blue-800 text-white' : 'bg-gray-200 text-gray-700'}`}
                                    >
                                        {curr}
                                    </button>
                                ))}
                            </div>

                            <div>
                                <label className="block text-gray-700 text-sm font-bold mb-2">Amount</label>
                                <div className="grid grid-cols-3 gap-2 mb-4">
                                    {["100", "1000", "2000"].map((amount) => (
                                        <button
                                            key={amount}
                                            type="button"
                                            onClick={() => {
                                                setDonationAmount(amount);
                                                setShowCustomAmount(false);
                                                setUserInfo(prev => ({ ...prev, amount: amount }));
                                            }}
                                            className={`px-4 py-2 rounded ${donationAmount === amount && !showCustomAmount ? 'bg-blue-800 text-white' : 'bg-gray-200 text-gray-700'}`}
                                        >
                                            {currency} {amount}
                                        </button>
                                    ))}
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setShowCustomAmount(!showCustomAmount);
                                            setDonationAmount('');
                                        }}
                                        className={`px-4 py-2 rounded ${showCustomAmount ? 'bg-blue-800 text-white' : 'bg-gray-200 text-gray-700'}`}
                                    >
                                        Other
                                    </button>
                                </div>
                                {showCustomAmount && (
                                    <input
                                        type="number"
                                        placeholder="Enter custom amount"
                                        value={userInfo.amount || ''}
                                        onChange={(e) => {
                                            setUserInfo(prev => ({ ...prev, amount: e.target.value }));
                                        }}
                                        className="mb-4 px-4 py-2 rounded border border-gray-300 w-full"
                                    />
                                )}

                                <label className="block text-gray-700 text-sm font-bold mb-2">Donation Purpose</label>
                                <div className="flex space-x-4 mb-4">
                                    {['General', 'Zakat', 'Sadqah'].map((curr) => (
                                        <button
                                            key={curr}
                                            type="button"
                                            onClick={() => {
                                                setDonationPurpose(curr);
                                                setUserInfo(prev => ({ ...prev, donationPurpose: curr }));
                                            }}
                                            className={`px-4 py-2 rounded ${donationPurpose === curr ? 'bg-blue-800 text-white' : 'bg-gray-200 text-gray-700'}`}
                                        >
                                            {curr}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <button
                            type="button"
                            onClick={nextStep}
                            className="w-full bg-blue-800 text-white px-4 py-2 rounded hover:bg-blue-600"
                        >
                            Next
                        </button>
                    </div>
                )}

                {step === 2 && (
                    <div>
                        <h3 className="text-lg font-semibold mb-4">Enter Your Information</h3>
                        <div className="space-y-4">
                            <div className="grid grid-cols-2 gap-4">
                                <input
                                    type="text"
                                    name="firstName"
                                    placeholder="First Name"
                                    value={userInfo.firstName}
                                    onChange={handleUserInfoChange}
                                    className="px-4 py-2 rounded border border-gray-300"
                                />
                                <input
                                    type="text"
                                    name="lastName"
                                    placeholder="Last Name"
                                    value={userInfo.lastName}
                                    onChange={handleUserInfoChange}
                                    className="px-4 py-2 rounded border border-gray-300"
                                />
                            </div>
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={userInfo.email}
                                onChange={handleUserInfoChange}
                                className="w-full px-4 py-2 rounded border border-gray-300"
                            />
                            <input
                                type="text"
                                name="contactNumber"
                                placeholder="Contact Number"
                                value={userInfo.contactNumber}
                                onChange={handleUserInfoChange}
                                className="w-full px-4 py-2 rounded border border-gray-300"
                            />
                            <input
                                type="text"
                                name="address"
                                placeholder="Address"
                                value={userInfo.address}
                                onChange={handleUserInfoChange}
                                className="w-full px-4 py-2 rounded border border-gray-300"
                            />
                            <div className="grid grid-cols-2 gap-4">
                                <select
                                    name="country"
                                    value={userInfo.country}
                                    onChange={handleUserInfoChange}
                                    className="px-4 py-2 rounded border border-gray-300"
                                >
                                    <option value="Pakistan">Pakistan</option>
                                </select>
                                <select
                                    name="province"
                                    value={userInfo.province}
                                    onChange={handleUserInfoChange}
                                    className="px-4 py-2 rounded border border-gray-300"
                                >
                                    <option value="">Select Province</option>
                                    <option value="Sindh">Sindh</option>
                                    <option value="Punjab">Punjab</option>
                                    <option value="Balochistan">Balochistan</option>
                                    <option value="KPK">KPK</option>
                                </select>
                            </div>
                            <div className="grid grid-cols-2 gap-4">
                                <input
                                    type="text"
                                    name="zipCode"
                                    placeholder="Zip/Postal Code"
                                    value={userInfo.zipCode}
                                    onChange={handleUserInfoChange}
                                    className="px-4 py-2 rounded border border-gray-300"
                                />
                                <input
                                    type="text"
                                    name="city"
                                    placeholder="City"
                                    value={userInfo.city}
                                    onChange={handleUserInfoChange}
                                    className="px-4 py-2 rounded border border-gray-300"
                                />
                            </div>
                        </div>
                        <div className="flex justify-between mt-4">
                            <button
                                type="button"
                                onClick={prevStep}
                                className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                            >
                                Back
                            </button>
                            <button
                                type="submit"
                                className="bg-blue-800 text-white px-4 py-2 rounded hover:bg-red-600"
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                )}
            </form>
        </div>
    );
};

export default DonationForm;